import { QIcon_bar_graph, QIcon_chat, QIcon_chevron_right } from '@repo/icons/index'
import { useState } from 'react'
import { useLocale } from '../../../../modules/context/LocaleContext'
import { APP_SCREEN_NAME } from '../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useRNMsg from '../../../../modules/hooks/webview/common/useRNMsg'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_analysis } from '../../../../modules/i18n/strings/auto/wording'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { locationMoveLocaleNewTab } from '../../../../modules/utils'
import { COLORS } from '../../../../modules/vars'
import NewTag from '../../../common/menu/NewTag'
import useCafJobAnalysisSidePopup from '../CAFOverview/popup/useCafJobAnalysisSidePopup'
import useJobAnalysisPopup from '../CAFOverview/popup/useJobAnalysisPopup'
import JobAnalysisModal from './JobAnalysis/JobAnalysisModal'

const TIPSection = () => {
  const { locale } = useLocale()
  const { isLocaleKO } = useTranslation()
  const { t } = useTranslation()
  const { sendPostMsg } = useRNMsg()
  const isWebview = useIsWebview()
  const router = useAppRouter()

  const [showAlertPopup, setShowAlertPopup] = useState(false)
  const [showJobInputPopup, setShowJobInputPopup] = useState(false)
  const { isShowAlertPopup, isShowJobInputPopup, info } = useJobAnalysisPopup()
  const { show, close } = useCafJobAnalysisSidePopup()
  const getFullUrl = useReturnFullUrl()

  const handlClickFaqItem = () => {
    if (isWebview) {
      if (isLocaleKO) {
        router.push('', {
          appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
          appSendData: {
            url: 'https://www.ringleplus.com/ko/student/landing/blog/ai-analysis-about',
          },
        })
      } else {
        router.push('', {
          appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
          appSendData: {
            url: 'https://www.ringleplus.com/en/student/landing/blog/ai-analysis-about-eng',
          },
        })
      }
    } else {
      const cafLink = t([
        '/student/landing/blog/ai-analysis-about',
        '/student/landing/blog/ai-analysis-about-eng',
        '',
        '/student/landing/blog/english-related-17',
        '/student/landing/blog/english-related-13',
        '/student/landing/blog/ai-analysis-about-eng',
        '',
      ])
      locationMoveLocaleNewTab(cafLink)
    }
  }

  const handleClickJobItem = () => {
    if (isShowJobInputPopup) {
      if (isWebview) {
        router.push(urls.webview.caf.analysis.jobInput, {
          appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
          appSendData: { url: getFullUrl(urls.webview.caf.analysis.jobInput) },
        })
      } else {
        setShowJobInputPopup(true)
      }
    } else if (isShowAlertPopup) {
      setShowAlertPopup(true)
    } else {
      if (isWebview) {
        router.push(urls.webview.caf.analysis.jobFilter, {
          appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
          appSendData: {
            url: getFullUrl(urls.webview.caf.analysis.jobFilter),
          },
        })
      } else {
        show()
      }
    }
  }

  return (
    <>
      <section className="flex w-full flex-col gap-[12px] pb-[32px] pt-[24px]">
        <div
          className="border-1 flex cursor-pointer flex-row items-center justify-start rounded-[8px] border-gray-100 bg-white p-[12px] shadow-[0_2px_10px_-2px_rgba(22,28,45,0.06)]"
          onClick={handleClickJobItem}
        >
          <div className="flex w-full flex-row items-center justify-start gap-[8px] ">
            <QIcon_bar_graph width={20} height={20} color={COLORS.GRAY400} />
            <p className="Body1-16Bd text-black">{t(n_ai_analysis.side_menu_job_segment)}</p>
            <NewTag tipSection />
          </div>
          <QIcon_chevron_right width={16} height={16} color={COLORS.GRAY500} />
        </div>
        <div
          className="border-1 flex cursor-pointer flex-row items-center justify-start gap-[8px] rounded-[8px] border-gray-100 bg-white p-[12px] shadow-[0_2px_10px_-2px_rgba(22,28,45,0.06)]"
          onClick={handlClickFaqItem}
        >
          <QIcon_chat width={20} height={20} color={COLORS.GRAY400} />
          <p className="Body1-16Bd w-full text-black">{t(n_caf.overview.faq_title)}</p>
          <QIcon_chevron_right width={16} height={16} color={COLORS.GRAY500} />
        </div>
      </section>
      <JobAnalysisModal
        isShowAlertPopup={isShowAlertPopup}
        showAlertPopup={showAlertPopup}
        setShowAlertPopup={setShowAlertPopup}
        info={info}
        isShowJobInputPopup={isShowJobInputPopup}
        showJobInputPopup={showJobInputPopup}
        setShowJobInputPopup={setShowJobInputPopup}
      />
    </>
  )
}

export default TIPSection
